import React, { useEffect, useMemo } from 'react'
import Select from 'react-select'
import { useMasterData } from '../../utils/useMasterData'

function AddFinancePartner({ sendDataToParent, onLoad }) {
  const { items: interestRateItems, loading: interestRateLoading } = useMasterData('interestRates')

  const interestRateOptions = useMemo(() => {
    return (interestRateItems || []).map((item) => ({
      value: item.ValueName ?? '',
      label: item.DisplayName || item.ValueName || '',
      id: item.MasterValueId
    }))
  }, [interestRateItems])

  function handleChange(e) {
    const { name, value } = e.currentTarget
    sendDataToParent((prevState) => ({
      ...(prevState ?? {}),
      [name]: value,
    }))
  }

  const handleInterestRateChange = (option) => {
    const value = option ? option.value : ''
    sendDataToParent((prevState) => ({
      ...(prevState ?? {}),
      InterestRate: value,
    }))
  }

  useEffect(() => {
    onLoad?.(undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Finance Partner Name<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="FinancePartnerName"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Interest Rate (%)</label>
          <Select
            classNamePrefix="react-select"
            options={interestRateOptions}
            isLoading={interestRateLoading}
            isClearable
            placeholder="Select interest rate"
            onChange={handleInterestRateChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Minimum Down Payment</label>
          <input
            type="number"
            className="form-control"
            name="MinimumDownPayment"
            step="0.01"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Person 1</label>
          <input
            type="text"
            className="form-control"
            name="ContactPerson1"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Phone 1</label>
          <input
            type="text"
            className="form-control"
            name="ContactPhone1"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Person 2</label>
          <input
            type="text"
            className="form-control"
            name="ContactPerson2"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Phone 2</label>
          <input
            type="text"
            className="form-control"
            name="ContactPhone2"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Sequance</label>
          <input
            type="number"
            className="form-control"
            name="Sequance"
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )
}

export default AddFinancePartner
